// extracted by mini-css-extract-plugin
export default {"display":"PageNotFound_display__IvvKe"};